import React, { Component } from 'react';

class StationSearchResult extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {
    return (
      <div
        onClick={this.props.onResultClick(this.props.station)}>
        <div className="content">
          <p className="title">
            {this.props.station.title}
          </p>
          <p className="subtitle">
            {this.props.station.subtitle}
          </p>
        </div>
        <div className="aside">
          <p className="code">{this.props.station.code}</p>
        </div>
      </div>
    );
  }
};

export default StationSearchResult;
